'use client';

import React from 'react';

import CompactReferralsList from './CompactReferralsList';

const CompactOutboundReferrals: React.FC = () => (
  <CompactReferralsList
    direction="outbound"
    title="Outbound Referrals"
    testIdPrefix="compact-outbound-referrals"
  />
);

export default CompactOutboundReferrals;
